const listViolationRouter = [
    {
        path: "list_violation",
        name: "list_violation",
        component: () => import("@/views/admin/list_violation"),
        default: true,
        meta: {
            model: "list_violation",
            // requiresAuth: true,
        },
    },
    {
        path: "list_violation/add",
        name: "addListViolation",
        component: () => import("@/views/admin/list_violation/function"),
        default: true,
        meta: {
            model: "list_violation",
            // requiresAuth: true,
        },
    },
    {
        path: "list_violation/edit/:id",
        name: "editListViolation",
        component: () => import("@/views/admin/list_violation/function"),
        default: true,
        meta: {
            model: "list_violation",
            // requiresAuth: true,
        },
    }
]
export default listViolationRouter;
